import React from "react";

export default function Svg({id, className = '', onClick = () => {}, style = {}}) {
    if (!id) {
        console.warn('id is not defined!')
        return null;
    }

    return (
        <svg className={className} onClick={onClick} style={style}>
            <use href={`#${id}`} xlinkHref={`#${id}`}></use>
        </svg>
    );
}
